<div class="display-flex align-items-center flex-column grid-gap-4" [title]="userName ? userName : 'No user selected'">
  <ng-container [ngTemplateOutlet]="iconBox"></ng-container>
  <ng-container *ngIf="showName" [ngTemplateOutlet]="fullNameTemplate"></ng-container>
</div>

<ng-template #iconBox>
  <div class="avatar display-flex justify-content-center align-items-center" [ngClass]="[containerCss, avatarTheme]">
    <div class="initials">{{ initials || '??' }}</div>
  </div>
</ng-template>

<ng-template #fullNameTemplate>
  <div class="user-name nowrap" *ngIf="userId">{{ firstName }} {{ lastName }}</div>
  <div class="user-name" *ngIf="!userId">No user selected</div>
</ng-template>
